/* =====================================================
   pl-slideshow.js — PC/SP別スライドショー（自己完結）
   プラザ佐久 Shopify テーマ (Dawn 15.4.1)
   - DOMContentLoaded + shopify:section:load で初期化
   - 矢印・ページネーション（ドット/カウンター/数字）・スワイプ対応
   - designMode / prefers-reduced-motion 時は自動再生なし
   - shopify:block:select でスライドジャンプ
   - セクション単位でスコープ（複数インスタンス対応）
   ===================================================== */
(function () {
  'use strict';

  function PlSlideshow(rootEl) {
    if (!rootEl || rootEl._plSsInit) return;
    rootEl._plSsInit = true;

    var slides = Array.from(rootEl.querySelectorAll('.pl-ss__slide'));
    var total  = slides.length;
    if (total === 0) return;

    var track   = rootEl.querySelector('.pl-ss__track');
    var btnPrev = rootEl.querySelector('.pl-ss__arrow--prev');
    var btnNext = rootEl.querySelector('.pl-ss__arrow--next');
    var pgn     = rootEl.querySelector('.pl-ss__pagination');

    var autoplay      = rootEl.dataset.autoplay === 'true';
    var speed         = (parseInt(rootEl.dataset.speed, 10) || 5) * 1000;
    var visual        = rootEl.dataset.visual || 'counter';
    var current       = 0;
    var timer         = null;
    var designMode    = typeof Shopify !== 'undefined' && !!Shopify.designMode;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- コア：スライド切替 ---- */
    function goTo(idx) {
      idx = ((idx % total) + total) % total;
      slides[current].classList.remove('is-active');
      current = idx;
      slides[current].classList.add('is-active');
      syncPagination();
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    /* ---- ページネーション同期 ---- */
    function syncPagination() {
      if (!pgn) return;
      if (visual === 'counter') {
        var el = pgn.querySelector('.pl-ss__counter-current');
        if (el) el.textContent = current + 1;
      } else {
        pgn.querySelectorAll('[data-index]').forEach(function (b, i) {
          b.classList.toggle('is-active', i === current);
        });
      }
    }

    /* ---- 自動再生 ---- */
    function startTimer() {
      if (!autoplay || designMode || reducedMotion || total <= 1) return;
      timer = setInterval(next, speed);
      rootEl._plSsTimer = timer;
    }
    function stopTimer() {
      clearInterval(timer);
      timer = null;
      rootEl._plSsTimer = null;
    }

    /* ---- 矢印 ---- */
    if (btnPrev) btnPrev.addEventListener('click', function () { stopTimer(); prev(); });
    if (btnNext) btnNext.addEventListener('click', function () { stopTimer(); next(); });

    /* ---- ページネーションボタン ---- */
    if (pgn) {
      pgn.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-index]');
        if (!btn) return;
        stopTimer();
        goTo(parseInt(btn.dataset.index, 10));
      });
    }

    /* ---- タッチスワイプ ---- */
    if (track) {
      var touchStartX = 0;
      track.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          stopTimer();
          diff > 0 ? next() : prev();
        }
      }, { passive: true });
    }

    /* ---- ホバー一時停止 ---- */
    rootEl.addEventListener('mouseenter', stopTimer);
    rootEl.addEventListener('mouseleave', startTimer);

    /* ---- 外部API（shopify:block:select で使用） ---- */
    rootEl._plSsApi = { goTo: goTo, stopTimer: stopTimer, getCurrent: function () { return current; } };

    startTimer();
  }

  /* ---- 全インスタンス初期化 ---- */
  function initAll() {
    document.querySelectorAll('.pl-ss').forEach(function (el) {
      PlSlideshow(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);

  /* ---- テーマエディタ：セクション再読み込み ---- */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pl-ss');
    if (!el) return;
    /* セクション再レンダリング後は新要素なので初期化フラグをリセット */
    el._plSsInit = false;
    el._plSsTimer = null;
    el._plSsApi   = null;
    PlSlideshow(el);
  });

  /* ---- テーマエディタ：セクションアンロード（タイマークリーンアップ） ---- */
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('.pl-ss');
    if (el && el._plSsTimer) clearInterval(el._plSsTimer);
  });

  /* ---- テーマエディタ：ブロック選択でスライドジャンプ ---- */
  document.addEventListener('shopify:block:select', function (e) {
    var slideEl = e.target;
    if (!slideEl.classList.contains('pl-ss__slide')) return;
    var root = slideEl.closest('.pl-ss');
    if (!root) return;

    if (root._plSsApi) {
      /* 初期化済みインスタンスの goTo を使って current も同期 */
      var slides = Array.from(root.querySelectorAll('.pl-ss__slide'));
      var idx = slides.indexOf(slideEl);
      if (idx >= 0) root._plSsApi.goTo(idx);
    } else {
      /* 万が一未初期化なら直接クラス操作 */
      root.querySelectorAll('.pl-ss__slide').forEach(function (s) {
        s.classList.remove('is-active');
      });
      slideEl.classList.add('is-active');
    }
  });

})();
